import NodeMessaging from "messaging/NodeMessaging.js";
import {value} from 'nft/random.js';

export default class ZNFT extends NodeMessaging(class{}) {
    constructor(zobject) {
        super();
        this.zObject = zobject;
        this.sequencerEngine = zobject.sequencerEngine;
        this.subSequence = zobject.subSequence;

        // number of calls to execute to occur upon startup
        this.startUpNumber = 0;

        this.newInlet("Start Up Calls", (x) => this.startUpNumber = x[0]);
        this.newOutlet("Random Number");
    }

    getJson() {
        return {
            startUpNumber: this.startUpNumber
        };
    }

    fromJson(json) {
        this.startUpNumber = json.startUpNumber;
    }

    getParameters() {
        return [];
    }

    startUp() {
        for (let i=0; i < this.startUpNumber; i++) {
            this.execute();
        }
    }

    execute() {
        console.log('executing random number');
        this.sendMessage("Random Number", value());
    }
}
